<div class="scrollable">
<div class="caddie simple-explorer container" id="loadingOverlayTarget">

    <!-- Select cancer type -->
    <div class="field">
        <label class="label">Cancer Type</label>
        <div class="control">
            <ng-select
                [multiple]="false"
                [clearable]="false"
                [items]="cancerTypes"
                [(ngModel)]="cancerType"
                [virtualScroll]="true"
                bindLabel="name"
                disabled
                (ngModelChange)="selectCancerType($event)"
                >

                <!-- [disabled]="item.disabled" -->
                <ng-option *ngFor="let item of cancerTypes" [value]="item.backendId" >{{item.name}}</ng-option>
            </ng-select>
        </div>
        <p class="help">Select a cancer type to explore its related genes</p>
    </div>

    <app-explorer-network-information></app-explorer-network-information>
    
    <app-network [networkType]="'simple'" [target]="'none'"></app-network>


 <div class="card bar-large mt-1">
    <section class="hero">
        <div class="hero-body">
            <p class="title">
            Drug Search
            </p>

                <div
     class="notification is-info"
     *ngIf="analysis.getCount() === 0"
     >
        Select genes in the network with a double-click for the drug search. 
    </div>

    
            <p class="subtitle" *ngIf="analysis.getCount() > 0">
            Find drugs for all selected genes (this may take a minute):
            </p>
                <div class="text-center is-fullwidth mt-4" *ngIf="analysis.getCount() > 0">
        <button
            (click)="
            explorerData.exampleSearch('simple-drug');
            explorerData.deselectSelectedWrapper()
            "
            class="button is-primary has-tooltip"
            data-tooltip="Find drugs for the selected genes."
            
        >
            <span class="icon">
            <i class="fa fa-capsules"></i>
            </span>
            <span> Start </span>
        </button>
    </div>
        </div>
    </section>
</div>


     <app-info-tile
        *ngIf="explorerData.selectedWrapper"
      [wrapper]="explorerData.selectedWrapper"
      [wrapperCancerTypes]="explorerData.selectedWrapperCancerTypes"
      [wrapperComorbidities]="explorerData.selectedWrapperComorbidities"
      (updateSelectedWrapper)="explorerData.selectedWrapper = $event"
    ></app-info-tile>


    <!-- Task list -->
    <div class="card bar-large" *ngIf="analysis.tasks">
        <header class="card-header">
        <p class="card-header-title">
            <span class="icon">
            <i class="fas fa-tasks" aria-hidden="true"></i>
            </span>
            Tasks ({{ analysis.tasks.length }})
        </p>
        </header>
        <div>
        <app-task-list
            [token]="explorerData.selectedAnalysisToken"
            [taskList]="analysis.tasks"
            (tokenChange)="openSimpleAnalysis($event)"
        >
        </app-task-list>
        <footer class="card-footer">
            <a
            *ngIf="analysis.tasks.length > 0"
            (click)="
                analysis.removeAllTasks(); explorerData.selectedAnalysisToken = null
            "
            class="card-footer-item has-text-danger"
            data-tooltip="Delete all tasks."
            >
            <span class="icon">
                <i class="fa fa-trash"></i>
            </span>
            <span> Delete all </span>
            </a>
        </footer>
        </div>
    </div>




    <div class="modal" [class.is-active]="showResultModal">
        <div class="modal-background"></div>
        <div class="modal-card" id="simple-analysis-result-modal">
            <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon"><i class="fa fa-dna"></i></span>
                Drug Search Result
            </p>
            <button (click)="closeResultModal()" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
<div *ngIf="task !== null" class="card-content" id="analysis-content">
      <div class="tabs is-centered">
        <ul>
          <li [class.is-active]="tab === 'network'">
            <a (click)="tab = 'network'">Network</a>
          </li>
          <li [class.is-active]="tab === 'table'">
            <a (click)="tab = 'table'">Table</a>
          </li>
          <li [class.is-active]="tab === 'meta'" *ngIf="task.info.algorithm !== 'summary'">
            <a (click)="tab = 'meta'">Parameters</a>
          </li>
        </ul>
      </div>
      <div
        class="content tab-content meta scrollable"
        *ngIf="task && task.info.done"
        [class.is-visible]="tab === 'meta'"
      >
        <div *ngIf="task && result">
          <p
          >
            Algorithm:
            <strong>Trustrank</strong>
          </p>
          <div>
            <table class="table is-narrow">
              <tbody>
                <tr *ngIf="result.cancerDataset !== undefined">
                  <td>Cancer Dataset</td>
                  <td>{{ result.cancerDataset.name }}</td>
                </tr>
                <tr *ngIf="result.geneInteractionDataset !== undefined">
                  <td>Gene Interaction Dataset</td>
                  <td>{{ result.geneInteractionDataset.name }}</td>
                </tr>
                <tr
                  *ngIf="
                    result.drugInteractionDataset !== undefined &&
                    task.info.target === 'drug'
                  "
                >
                  <td>Drug Interaction Dataset</td>
                  <td>{{ result.drugInteractionDataset.name }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.cancerTypeNames !== undefined">
                  <td>Cancer Types</td>
                  <td>
                    {{ formatStringList(task.info.parameters.cancerTypeNames) }}
                  </td>
                </tr>

                <tr *ngIf="task.info.parameters.resultSize !== undefined">
                  <td>Result Size</td>
                  <td>{{ task.info.parameters.resultSize }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.k !== undefined">
                  <td>K</td>
                  <td>{{ task.info.parameters.k }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.numTrees !== undefined">
                  <td>Number of trees</td>
                  <td>{{ task.info.parameters.numTrees }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.tolerance !== undefined">
                  <td>Tolerance</td>
                  <td>{{ task.info.parameters.tolerance }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.dampingFactor !== undefined">
                  <td>Damping Factor</td>
                  <td>{{ task.info.parameters.dampingFactor }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.maxDeg !== undefined">
                  <td>Maximum Degree</td>
                  <td>{{ task.info.parameters.maxDeg }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.hubPenalty !== undefined">
                  <td>Hub Penality</td>
                  <td>{{ task.info.parameters.hubPenalty }}</td>
                </tr>
                <tr *ngIf="task.info.parameters.mutationWeights !== undefined">
                  <td>Mutation Weights</td>
                  <td>
                    <i
                      *ngIf="task.info.parameters.mutationWeights"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="!task.info.parameters.mutationWeights"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.includeIndirectDrugs !== undefined &&
                    task.info.target === 'drug'
                  "
                >
                  <td>Include indirect drugs</td>
                  <td>
                    <i
                      *ngIf="task.info.parameters.includeIndirectDrugs"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="!task.info.parameters.includeIndirectDrugs"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.includeNutraceuticalDrugs !==
                      undefined && task.info.target === 'drug'
                  "
                >
                  <td>Include nutraceutical drugs</td>
                  <td>
                    <i
                      *ngIf="task.info.parameters.includeNutraceuticalDrugs"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="!task.info.parameters.includeNutraceuticalDrugs"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.includeNonApprovedDrugs !==
                      undefined && task.info.target === 'drug'
                  "
                >
                  <td>Include non-approved drugs</td>
                  <td>
                    <i
                      *ngIf="task.info.parameters.includeNonApprovedDrugs"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="!task.info.parameters.includeNonApprovedDrugs"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.onlyAtcLDrugs !== undefined &&
                    task.info.target === 'drug'
                  "
                >
                  <td>Include only ATC class L drugs</td>
                  <td>
                    <i
                      *ngIf="task.info.parameters.onlyAtcLDrugs"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="!task.info.parameters.onlyAtcLDrugs"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.includeOnlyCtrpv2Drugs !== undefined &&
                    task.info.target === 'drug'
                  "
                >
                  <td>Include only CTRPv2 drugs</td>
                  <td>
                    <i
                      *ngIf="task.info.parameters.includeOnlyCtrpv2Drugs"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="!task.info.parameters.includeOnlyCtrpv2Drugs"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.ignoreNonSeedBaits !== undefined &&
                    task.info.target === 'drug-target'
                  "
                >
                  <td>Include non-seed Cancer Genes</td>
                  <td>
                    <i
                      *ngIf="!task.info.parameters.ignoreNonSeedBaits"
                      class="fa fa-check"
                    ></i>
                    <i
                      *ngIf="task.info.parameters.ignoreNonSeedBaits"
                      class="fa fa-times"
                    ></i>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.mutationCancerType !== null &&
                    task.info.parameters.mutationCancerType !== undefined
                  "
                >
                  <td>Cancer Type for Mutation Weights</td>
                  <td>{{ task.info.parameters.mutationCancerType }}</td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.expressionCancerType !== null &&
                    task.info.parameters.expressionCancerType !== undefined
                  "
                >
                  <td>Cancer Type for Expression Weights</td>
                  <td>{{ task.info.parameters.expressionCancerType }}</td>
                </tr>
                <tr
                  *ngIf="
                    task.info.parameters.drugTargetAction !== null &&
                    task.info.parameters.drugTargetAction !== undefined
                  "
                >
                  <td>Drug Target Action</td>
                  <td>{{ task.info.parameters.drugTargetAction }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
      </div>
      <div
        class="content tab-content"
        id="simple-analysis-network"
        *ngIf="task && task.info.done"
        [class.is-visible]="tab === 'network'"
      >
        <div class="card-image">
          <app-network [networkType]="'simpleAnalysis'" [target]="explorerData.activeNetwork.target"></app-network>
        </div>
      </div>
      <div
        class="content tab-content scrollable"
        id="simeAnalysisResultTableLength"
        *ngIf="task && task.info.done"
        [class.is-visible]="tab === 'table'"
      >
        <div
          class="field has-addons"
          *ngIf="tableHasScores"
        >
          <p class="control">
            <button
              class="button has-tooltip"
              data-tooltip="Normalize the scores"
              [class.is-primary]="tableNormalize"
              (click)="toggleNormalization(true)"
            >
              <span class="icon is-small">
                <i class="fa fa-ruler-vertical"></i>
              </span>
              <span>Normalization On</span>
            </button>
          </p>
          <p class="control">
            <button
              class="button has-tooltip"
              data-tooltip="Disable normalization of the scores."
              [class.is-primary]="!tableNormalize"
              (click)="toggleNormalization(false)"
            >
              <span>Off</span>
            </button>
          </p>
        </div>

        <div *ngIf="tableDrugs.length === 0 && task.info.target === 'drug'">
          <i>No drugs have been found.</i>
        </div>
        <div *ngIf="tableDrugs.length > 0" class="table-header">
          <h4 class="is-4">
            <span class="icon"><i class="fa fa-capsules"></i></span>
            <span>Drugs ({{ tableDrugs.length }})</span>
          </h4>
          <a
            [href]="downloadLink('drugs')"
            class="button is-primary is-outlined is-pulled-right is-small"
          >
            <span class="icon"><i class="fa fa-download"></i></span>
            <span>Download</span>
          </a>
        </div>
        <p-table *ngIf="tableDrugs.length > 0" [value]="tableDrugs">
          <ng-template pTemplate="header">
            <tr>
              <th [pSortableColumn]="'dbId'">
                DB ID
                <p-sortIcon [field]="'dbId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'name'">
                Name
                <p-sortIcon [field]="'name'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'status'">
                Approved
                <p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
              <!--              <th [pSortableColumn]="'inTrial'">-->
              <!--                In Trial-->
              <!--                <p-sortIcon [field]="'inTrial'"></p-sortIcon>-->
              <!--              </th>-->
              <th [pSortableColumn]="'isNutraceutical'">
                Is Nutraceutical
                <p-sortIcon [field]="'isNutraceutical'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="
                  'isAtcAntineoplasticAndImmunomodulatingAgent'
                "
                class="has-tooltip"
                data-tooltip="ATC Class L (Antineoplastic or Immunomodulating Agents)"
              >
                ATC L
                <p-sortIcon
                  [field]="'isAtcAntineoplasticAndImmunomodulatingAgent'"
                ></p-sortIcon>
              </th>
              <th [pSortableColumn]="'inCancernet'">
                CanceRx
                <p-sortIcon [field]="'inCancernet'"></p-sortIcon>
              </th>
              <th *ngIf="tableHasScores" [pSortableColumn]="'score'">
                Score
                <p-sortIcon [field]="'score'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'dbDegree'">
                Interactome Degree
                <p-sortIcon [field]="'dbDegree'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-e>
            <tr>
              <td>
                <a
                  href="https://www.drugbank.ca/drugs/{{ e.dbId }}"
                  target="_blank"
                  >{{ e.dbId }}</a
                >
              </td>
              <td>
                {{ e.name }}
              </td>
              <td>
                <span *ngIf="e.status === 'approved'">
                  <i class="fa fa-check"></i>
                  Approved
                </span>
                <span *ngIf="e.status === 'unapproved'">
                  <i class="fa fa-times"></i>
                </span>
              </td>
              <!--              <td>-->
              <!--                <span *ngIf="e.inTrial">-->
              <!--                  <i class="fa fa-microscope has-text-primary"></i>-->
              <!--                  Trial-->
              <!--                </span>-->
              <!--                <span *ngIf="!e.inTrial">-->
              <!--                  <i class="fa fa-times"></i>-->
              <!--                </span>-->
              <!--              </td>-->

              <td>
                <span *ngIf="e.isNutraceutical">
                  <i class="fa fa-leaf has-text-primary"></i>
                  Nutraceutical
                </span>
                <span *ngIf="!e.isNutraceutical">
                  <i class="fa fa-times"></i>
                </span>
              </td>
              <td>
                <span *ngIf="e.isAtcAntineoplasticAndImmunomodulatingAgent">
                  <i class="fa fa-check has-text-primary"></i>
                </span>
                <span *ngIf="!e.isAtcAntineoplasticAndImmunomodulatingAgent">
                  <i class="fa fa-times"></i>
                </span>
              </td>
              <td>
                <span *ngIf="e.inCancernet">
                  <i class="fa fa-check has-text-primary"></i>&nbsp;
                  <a (click)="explorerData.openCancernetModal(e)" ><i class="fa fa-external-link has-text-primary"></i></a>
                </span>
                <span *ngIf="!e.inCancernet">
                  <i class="fa fa-times"></i>
                </span>
              </td>
              <td *ngIf="tableHasScores">{{ e.score | number: "1.0-5" }}</td>
              <td>
                <span *ngIf="explorerData.activeNetwork.degrees !== undefined && e.graphId; in: explorerData.activeNetwork.degrees">
                  {{ explorerData.activeNetwork.degrees[e.graphId] }}
                </span>
                <span
                  *ngIf="!e.graphId; in: explorerData.activeNetwork.degrees"
                >
                  ?
                </span>
              </td>
              <!--              <td title="{{previewStringArray(e.closestCancerGenes, 100)}}">-->
              <!--                {{previewStringArray(e.closestCancerGenes, 3)}}-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                {{e.closestDistance}}-->
              <!--              </td>-->
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="tableNodes.length > 0" class="table-header">
          <h4 class="is-4">
            <span class="icon"><i class="fa fa-dna"></i></span>
            <span>Genes ({{ tableNodes.length }})</span>
          </h4>
          <a
            [href]="downloadLink('genes')"
            class="button is-primary is-outlined is-pulled-right is-small"
          >
            <span class="icon"><i class="fa fa-download"></i></span>
            <span>Download</span>
          </a>
        </div>
        <p-table
          *ngIf="tableNodes.length > 0"
          selectionMode="multiple"
          [value]="tableNodes"
          [selection]="tableSelectedNodes"
          dataKey="proteinAc"
        >
          <ng-template pTemplate="header">
            <tr>
              <th [pSortableColumn]="'proteinAc'">
                UniProt Code
                <p-sortIcon [field]="'proteinAc'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'name'">
                Gene
                <p-sortIcon [field]="'name'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'proteinName'">
                Protein Name
                <p-sortIcon [field]="'proteinName'"></p-sortIcon>
              </th>
              <th *ngIf="tableHasScores" [pSortableColumn]="'score'">
                Score
                <p-sortIcon [field]="'score'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'isSeed'">
                Seed
                <p-sortIcon [field]="'isSeed'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'dbDegree'">
                Interactome Degree
                <p-sortIcon [field]="'dbDegree'"></p-sortIcon>
              </th>
              <th *ngIf="task.info.algorithm === 'domino'" [pSortableColumn]="'cluster'">
                Cluster
                <p-sortIcon [field]="'cluster'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-e>
            <tr>
              <td>
                <a
                  href="https://www.uniprot.org/uniprot/{{ e.uniprotAc }}"
                  target="_blank"
                  >{{ e.uniprotAc }}</a
                >
              </td>
              <td>{{ e.name }}</td>
              <td>{{ e.proteinName }}</td>
              <td *ngIf="tableHasScores">{{ e.score | number: "1.0-5" }}</td>
              <td>
                <span *ngIf="e.isSeed">
                  <i class="fa fa-check"></i>
                  Seed
                </span>
                <span *ngIf="!e.isSeed">
                  <i class="fa fa-times"></i>
                </span>
              </td>
              <td>
                <span>
                  {{ e.dbDegree }}
                </span>
              </td>
              <td *ngIf="task.info.algorithm === 'domino'">
                <span *ngIf="e.cluster">
                  {{ e.cluster }}
                </span>
                <span *ngIf="!e.cluster">
                  -
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="tableCancerNodes.length > 0" class="table-header">
          <h4 class="is-4">
            <span class="icon"><i class="fa fa-disease"></i></span>
            <span>Cancer Driver Genes ({{ tableCancerNodes.length }})</span>
          </h4>
          <a
            [href]="downloadLink('cancer_driver_genes')"
            class="button is-primary is-outlined is-pulled-right is-small"
          >
            <span class="icon"><i class="fa fa-download"></i></span>
            <span>Download</span>
          </a>
        </div>
        <p-table
          *ngIf="tableCancerNodes.length > 0"
          selectionMode="multiple"
          [value]="tableCancerNodes"
          [selection]="tableSelectedCancerNodes"
          dataKey="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th [pSortableColumn]="'name'">
                Name
                <p-sortIcon [field]="'name'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'entrezId'">
                Entrez ID
                <p-sortIcon [field]="'entrezId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'cancerOccurrences'">
                Cancer Occurrences
                <p-sortIcon [field]="'cancerOccurrences'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'type'">
                Cancer Type
                <p-sortIcon [field]="'type'"></p-sortIcon>
              </th>
              <th *ngIf="tableHasScores" [pSortableColumn]="'score'">
                Score
                <p-sortIcon [field]="'score'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'isSeed'">
                Seed
                <p-sortIcon [field]="'isSeed'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'dbDegree'">
                Interactome Degree
                <p-sortIcon [field]="'dbDegree'"></p-sortIcon>
              </th>
              <th *ngIf="task.info.algorithm === 'domino'" [pSortableColumn]="'cluster'">
                Cluster
                <p-sortIcon [field]="'cluster'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-e>
            <tr>
              <td>{{ e.name }}</td>
              <td>
                <a href="https://www.ncbi.nlm.nih.gov/gene/{{ e.entrezId }}">{{
                  e.entrezId
                }}</a>
              </td>
              <td>{{ e.cancerOccurrences }}</td>
              <td>{{ e.type }}</td>
              <td *ngIf="tableHasScores">
                <span *ngIf="e.score">{{ e.score | number: "1.0-5" }}</span>
                <span *ngIf="!e.score">N/A</span>
              </td>
              <td>
                <span *ngIf="e.isSeed">
                  <i class="fa fa-asterisk has-text-primary"></i>
                  Seed
                </span>
                <span *ngIf="!e.isSeed">
                  <i class="fa fa-times"></i>
                </span>
              </td>
              <td>
                <span>
                  {{ e.dbDegree }}
                </span>
              </td>
              <td *ngIf="task.info.algorithm === 'domino'">
                <span *ngIf="e.cluster">
                  {{ e.cluster }}
                </span>
                <span *ngIf="!e.cluster">
                  -
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
            </section>

            <footer class="modal-card-foot">
                <button (click)="closeResultModal()" class="button has-tooltip">
                    Close
                </button>
            </footer>
        </div>
    </div>








    <!-- MODALS -->

    <app-network-menu-dialog [(show)]="explorerData.showNetworkMenuDialog">
    </app-network-menu-dialog>

    <app-custom-genes
    [(show)]="explorerData.showCustomGenesDialog"
    [visibleNodes]="explorerData.activeNetwork.basicNodes"
    (showChange)="(explorerData.showChangeCustomGenes)"
    >
    </app-custom-genes>

    <app-add-expressed-genes
    [(show)]="explorerData.showTissueThresholdDialog"
    [tissue]="explorerData.activeNetwork.selectedTissue"
    >
    </app-add-expressed-genes>

    <app-add-cancer-expressed-genes
    [(show)]="explorerData.showCancerThresholdDialog"
    [selectedExpressionCancerType]="
        explorerData.activeNetwork.selectedExpressionCancerType
    "
    [visibleNodes]="explorerData.activeNetwork.basicNodes"
    [basicNodes]="explorerData.activeNetwork.basicNodes"
    [cancerNodes]="explorerData.activeNetwork.cancerNodes"
    >
    </app-add-cancer-expressed-genes>

    <app-add-mutated-genes
    [(show)]="explorerData.showMutationThresholdDialog"
    [selectedMutationCancerType]="
        explorerData.activeNetwork.selectedMutationCancerType
    "
    [visibleNodes]="explorerData.activeNetwork.basicNodes"
    [basicNodes]="explorerData.activeNetwork.basicNodes"
    [cancerNodes]="explorerData.activeNetwork.cancerNodes"
    >
    </app-add-mutated-genes>

    <app-disease-related-genes
    [(show)]="explorerData.showDiseaseSelectionDialog"
    (showChange)="(explorerData.showChangeDiseaseSelectionDialog)"
    [visibleNodes]="explorerData.activeNetwork.basicNodes"
    [basicNodes]="explorerData.activeNetwork.basicNodes"
    [cancerNodes]="explorerData.activeNetwork.cancerNodes"
    >
    </app-disease-related-genes>

    <app-vcf-input
    [(show)]="explorerData.showVCFInput"
    (showChange)="(explorerData.showChangeVCFInput)"
    (triggerTemplateUpdate)="(explorerData.triggerTemplateUpdateVCFInput)"
    >
    </app-vcf-input>

    <app-cancernet-panel [drug]="explorerData.cancernetDrug" [(show)]="explorerData.showCancernetModal" (closeEvent)="explorerData.closeCancernetModal()"></app-cancernet-panel>



</div>
</div>